
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '@/context/SupabaseAuthContext';
import { HelmetProvider } from 'react-helmet-async';
import AppRoutes from './routes/AppRoutes';
import { Toaster } from '@/components/ui/toaster';

function App() {
  // App component rendering
  const [error, setError] = useState<Error | null>(null);
  
  // Set up global error boundary
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.error('Global error caught in App component:', event.error);
      setError(event.error);
    };
    
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);
  
  // If there's an error, show error UI
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-red-50 p-4">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Application Error</h1>
        <p className="text-red-800 mb-4">
          {error.message || 'An unexpected error occurred in the application.'}
        </p>
        <button 
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          onClick={() => window.location.reload()}
        >
          Reload Application
        </button>
      </div>
    );
  }
  
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <AppRoutes />
          <Toaster />
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
